import { createReducer, isAnyOf } from '@reduxjs/toolkit';
import {
  sendMessage,
  sendMessageFailure,
  sendMessageSuccess,
} from 'modules/chat/actions';

/**
 * @typedef {boolean} IsLoadingState
 */

/** @type {IsLoadingState} */
const initialState = false;

const load = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addMatcher(sendMessage.match, load)
    .addMatcher(isAnyOf(sendMessageSuccess.match, sendMessageFailure.match), reset);
});
